import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'core/libs/lodash';

import UserContext from '.';

import loadScript from 'core/utils/load-script';

const initialState = {
  isAuthorized: false,
  userInfo: null,
  notify: false,
};

export default class UserProvider extends React.PureComponent {
  static contextTypes = {
    ugcApi: PropTypes.object,
    features: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      resolved: false,
      setUserNotify: this.setUserNotify,
    };
  }

  componentDidMount() {
    window.ramblerIdHelper = window.ramblerIdHelper || [];

    window.ramblerIdHelper.push(() => {
      window.ramblerIdHelper.addListener('close', window.ramblerIdHelper.closeAuth);
      window.ramblerIdHelper.addListener('login', this.updateUser);
      window.ramblerIdHelper.addListener('oauthlogin', this.updateUser);
      window.ramblerIdHelper.addListener('logout', this.resetUser);
    });

    loadScript('https://id.rambler.ru/rambler-id-helper/auth_events.js')
      .then(this.updateUser);
  }

  componentWillUnmount() {
    if (window.ramblerIdHelper && window.ramblerIdHelper.removeListener) {
      window.ramblerIdHelper.removeListener('close', window.ramblerIdHelper.closeAuth);
      window.ramblerIdHelper.removeListener('login', this.updateUser);
      window.ramblerIdHelper.removeListener('oauthlogin', this.updateUser);
      window.ramblerIdHelper.removeListener('logout', this.resetUser);
    }
  }

  updateUser = () => {
    const {
      features: {
        enableUgc,
      },
      ugcApi,
    } = this.context;

    if (window.ramblerIdHelper && typeof window.ramblerIdHelper.getProfileInfo === 'function') {
      window.ramblerIdHelper.getProfileInfo({ get_chain_id: 1 }, userInfo => {
        const isAuthorized = !!userInfo;
        this.setState(
          { isAuthorized, userInfo, resolved: true },
          () => {
            if (!isAuthorized || !enableUgc) return;
            /**
             * Получаем информацию о том, что пользователю нужно показать иконку
             * нотификации, котораю говорить о том, что у него есть отклоненные
             * материалы. Делаем запрос тут, для того чтобы нотификацию можно было
             * показать за пределами личного кабинета.
             */
            ugcApi.getTopics({ publication_state: 'rejected' })
              .then(response => {
                const hasRejected = !!get(response, 'body.data', []).length;
                this.setUserNotify(hasRejected);
              });
          }
        );
      });
    }
  };

  resetUser = () => {
    this.setState({
      ...initialState,
    });
  };

  setUserNotify = notify => {
    this.setState({ notify });
  };

  render() {
    return (
      <UserContext.Provider
        value={this.state}
      >
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
